import "./PoweredByConstellation.scss";
import PropTypes from "prop-types";
// Imported, not require()d: CRA's require() of an .svg returns a module, not the URL.
import constellationLogo from "../../assets/imgs/automated-offers/logo.svg";

/** `stacked` puts the label above the logo. */
function PoweredByConstellation({ stacked = false, className = "" }) {
	return (
		<div
			className={`powered-by${stacked ? " powered-by--stacked" : ""} ${className}`.trim()}>
			<span className="powered-by__label">Powered and administered by</span>
			<img
				src={constellationLogo}
				alt="Constellation"
				className="powered-by__logo"
				width={130}
				height={32}
				decoding="async"
			/>
		</div>
	);
}

PoweredByConstellation.propTypes = {
	stacked: PropTypes.bool,
	className: PropTypes.string,
};

export default PoweredByConstellation;
